import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';

export default function useSearchOrders(searchTerm, readyToOrderOnly = false) {
  const shouldFetch = !!searchTerm;
  const url = shouldFetch
    ? `${apiBaseURL}/api/Orders/search?ReadyToOrderOnly=${readyToOrderOnly}&search=${encodeURIComponent(searchTerm)}`
    : null;

  const { data, error, isLoading } = useSWR(url, {
    revalidateOnFocus: false,
    dedupingInterval: 300000,
    onSuccess: (data) => {
      console.log('Searched orders fetched successfully:', data?.data);
    },
    onError: (err) => {
      console.error('Error fetching searched orders:', err);
    },
  });

  const noResults = !isLoading && shouldFetch && Array.isArray(data?.data) && data.data.length === 0;

  return {
    orders: data?.data || [],
    isLoading,
    error,
    noResults,
  };
}
